import React from "react";

import { Image } from "Components/atoms/Image";
import { Typography } from "Components/atoms/Typography";
import { NavMenu } from "Components/molecules/NavMenu";

import {
  FooterContentMobile,
  FooterWrapperMobile,
  LogoWrapperMobile,
  NavDescriptionMobile,
  NavWrapperMobile,
} from "./styles";

import { FooterProps } from "../types";
import { ReclameAquiSeal } from "Components/atoms/ReclameAqui/ReclameAquiSeal";

/**
 * Componente FooterMobile
 *
 * Exibe o rodapé otimizado para dispositivos mobile.
 */
export const FooterMobile: React.FC<FooterProps> = ({
  travelOptionsImage,
  travelOptionsImageAlt,
  logo: Logo,
  footerItems,
  descriptionTexts,
  subFooterText,
}) => {
  return (
    <FooterWrapperMobile>
      <FooterContentMobile>
        <LogoWrapperMobile href="/">
          <Logo />
        </LogoWrapperMobile>

        <NavWrapperMobile>
          <NavMenu
            items={footerItems.map((item) => ({
              label: item.label,
              action: () => item.action(),
            }))}
          />
        </NavWrapperMobile>

        <Typography variant="caption" color="darkBlue" align="center">
          {subFooterText}
        </Typography>

        <NavDescriptionMobile>
          <>
            {descriptionTexts.map((text, index) => (
              <Typography
                key={index}
                variant="caption"
                color="darkBlue"
                align="center"
              >
                {text}
              </Typography>
            ))}
            <ReclameAquiSeal />
          </>
        </NavDescriptionMobile>
      </FooterContentMobile>
      <Image src={travelOptionsImage} alt={travelOptionsImageAlt} width="380" />
    </FooterWrapperMobile>
  );
};
